import { Bar } from './ui/bits.jsx';
import { today } from '../lib/format.js';
import { Icon } from './ui/Icon.jsx';
import { t } from '../i18n/index.js';

/*
  Pot do izpita.

  Prej je bil to seznam kljukic brez občutka za razdaljo. Zdaj kartica
  najprej pove, koliko pogojev je izpolnjenih, in vsak pogoj, ki še ni,
  pokaže tudi KOLIKO manjka — „38/50 letov, manjka še 12“ je uporabno,
  „Vsaj 50 potrjenih letov“ brez števila ni.
*/

export function ExamCard({ check, onToggleTeorija, onSetZdravniski, compact = false }) {
  const done = check.ready;

  return (
    <section
      className={`card${done ? ' card--ok' : ''}`}
      aria-labelledby="exam-title"
      style={compact ? undefined : { marginBottom: 'var(--s-5)' }}
    >
      <div className="card__body stack">
        <div className="row">
          <Icon name={done ? 'award' : 'compass'} size={24} className={done ? 't-ok' : 't-brand'} />
          <div className="spacer">
            <h3 id="exam-title" className={done ? 't-ok' : undefined}>
              {done ? t('Pripravljen na izpit') : t('Pot do izpita')}
            </h3>
            <p className="t-sm t-dim">
              {done
                ? t('Vsi pogoji so izpolnjeni.')
                : t('Izpolnjenih {a} od {b} pogojev.', { a: check.ok, b: check.total })}
            </p>
          </div>
          <span className={`t-lg t-black num ${done ? 't-ok' : 't-brand'}`}>
            {check.ok}/{check.total}
          </span>
        </div>

        <Bar
          done={check.ok}
          total={check.total}
          ok={done}
          label={t('Pogoji za izpit: {a} od {b}', { a: check.ok, b: check.total })}
        />

        {check.med?.expiringSoon && (
          <p className="badge badge--wait" style={{ alignSelf: 'flex-start' }}>
            <Icon name="clock" size={13} /> {t('Zdravniško poteče čez {n} dni', { n: check.med.daysLeft })}
          </p>
        )}

        <ul className="stack stack--tight" style={{ listStyle: 'none', marginTop: 'var(--s-1)' }}>
          {check.items.map((it) => (
            <li key={it.key} className="row row--wrap" style={{ gap: 'var(--s-2) var(--s-3)' }}>
              <Mark ok={it.ok} unknown={it.unknown} />

              {/* Besedilo dobi vsaj 150 px; polje ali gumb gresta na ozkem v novo vrstico. */}
              <span
                className={`t-md${it.ok ? '' : ' t-dim'}`}
                style={{ flex: '1 1 150px', minWidth: 0, textDecoration: it.ok ? 'none' : undefined }}
              >
                {it.label}
              </span>

              {it.detail && (
                <span className={`t-sm num ${it.ok ? 't-dimmer' : 't-brand t-bold'}`}>
                  {it.detail}
                </span>
              )}

              {onToggleTeorija && it.key === 'teorija' && (
                <button
                  className="btn btn--sm btn--secondary"
                  onClick={() => onToggleTeorija(!it.ok)}
                >
                  {it.ok ? t('Razveljavi') : t('Označi opravljeno')}
                </button>
              )}

              {onSetZdravniski && it.key === 'zdravniski' && (
                <input
                  type="date"
                  className="input"
                  style={{ width: 150, minHeight: 34 }}
                  max={today()}
                  value={check.med?.examined ?? ''}
                  aria-label={t('Datum zdravniškega pregleda')}
                  title={t('Datum pregleda, ne datum nalaganja dokumenta')}
                  onChange={(e) => onSetZdravniski(e.target.value || null)}
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function Mark({ ok, unknown }) {
  const style = {
    width: 22,
    height: 22,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
    fontSize: 12,
    fontWeight: 800,
  };

  if (unknown) {
    return (
      <span
        style={{ ...style, background: 'var(--surface-3)', color: 'var(--text-3)' }}
        aria-label={t('Se preverja')}
      >
        …
      </span>
    );
  }

  return ok ? (
    <span style={{ ...style, background: 'var(--ok-fill)', color: '#fff' }} aria-label={t('Izpolnjeno')}>
      <Icon name="check" size={13} strokeWidth={2.6} />
    </span>
  ) : (
    <span
      style={{ ...style, background: 'var(--surface-3)', color: 'var(--text-3)' }}
      aria-label={t('Še ni izpolnjeno')}
    />
  );
}
